<template>
  <div class="screen-back">
    <i class="el-icon-close"></i>
    <span class="text">退出</span>
  </div>
</template>

<script>
export default {
  name: "Screen"
};
</script>

<style lang="scss">
.screen-back {
  width: 155px;
  text-align: center;
  line-height: 70px;
  height: 70px;
  background: rgba(0, 0, 0, 1);
  opacity: 0.7003;

  color: white;

  font-size: 20px;

  cursor: pointer;

  .text {
    margin-left: 20px;
  }
}
</style>